module.exports = "https://web-assets.ifttt.com/packs/media/docs/buggyappletpage-1f0e6049.png";